// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"1b0267ec","535":"46e442bb","640":"259edec5","787":"8d91f1f7"}[chunkId] + ".chunk.js";
};